import { snackbarAction } from './snackbarAction';
import { snackbarDuration } from './snackbarDuration';
import { snackbarText } from './snackbarText';
import { me } from './me';
import { renewingAuthToken } from './renewingAuthToken';
import { user } from './user';
import { loading } from './loading';
import { dedicatedContracts } from './dedicated-contracts';
import { routes } from './routes';

const reducers = {
  snackbarAction,
  snackbarDuration,
  snackbarText,
  me,
  renewingAuthToken,
  user,
  loading,
  dedicatedContracts,
  routes,
};

export default reducers;
